import { Box, Button, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import photo from '../../assets/images/homeImage.png';
import logo from '../../assets/images/logo-black.svg';
import cognitoService from '../../core/service/cognito.service';
import AccountCreation from './AccountCreation';
import styles from './login.module.scss';
import NavMobile from '../Nav/NavMobile';
import { SET_USER_DATA } from '../../constants/actionTypes';
import { getRandomRightSectionImageSrc } from '../../utils/images';

const mapStateToProps = (state) => ({
    user: state.user.currentUser
});

const mapDispatchToProps = (dispatch) => ({
    onSetUserData: (payload) => dispatch({ type: SET_USER_DATA, payload })
});

const RegisterPage = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [showImage, setShowImage] = useState(true);
    const [username, setUsername] = useState('');
    const [emailError, setEmailError] = useState('');
    const [confirmCode, setConfirmCode] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!username) {
                throw new Error(t('UserNotExistMessage'));
            }
            props.onSetUserData({ username, step: true });
            setLoading(true);
            const authReq = await cognitoService.register(username);
            setLoading(false);
            setEmailError(null);
            if (authReq) {
                setShowImage(false);
                setConfirmCode(true);
            }
        } catch (e) {
            setLoading(false);
            if (e.code && e.code === 'UserLambdaValidationException') {
                setEmailError(t('UserNotExistMessage'));
                return;
            } else if (e.code && e.code === 'UsernameExistsException') {
                setEmailError(t('EmailAccountExistsSignIn'));
                return;
            }
            setEmailError(e.message);
        }
    };

    const backgroundPhotoSrc = useMemo(() => getRandomRightSectionImageSrc(), []);

    return (
        <Box className={styles.registerContainer}>
            {isMobile && <NavMobile />}
            <Box className={styles.content}>
                {!isMobile && (
                    <Box className={styles.flex} sx={{ padding: 0, margin: '0 -4rem' }}>
                        <img
                            style={{ cursor: 'pointer', width: '40px', height: '40px' }}
                            onClick={() => history.push('/home')}
                            src={logo}
                            alt="logo"
                        />
                        <Box className={styles.flexNav}>
                            {/* <Link>{t('About')}</Link> */}
                            <Link to={'/terms-and-conditions'}>{t('TermsAndConditions')}</Link>
                        </Box>
                    </Box>
                )}
                {isMobile && showImage && (
                    <Box className={styles.imageWrapper}>
                        <Box className={styles.backgroundImage}></Box>
                        <Box className={styles.gradientOverlay}></Box>
                    </Box>
                )}
                <Box
                    className={styles.registerContent}
                    sx={{ margin: isMobile && showImage ? '60% auto 0 !important' : '' }}>
                    <Typography
                        sx={{
                            margin: '1rem 0',
                            zIndex: 2,
                            fontSize: isMobile ? '38px' : '64px',
                            letterSpacing: isMobile ? '-0.78px' : '-1.28px'
                        }}
                        fontFamily={'InstrumentSans-bold'}
                        textAlign={'center'}>
                        {t('RegisterYourEmail')}
                    </Typography>
                    <AccountCreation
                        handleSubmit={handleSubmit}
                        setUsername={setUsername}
                        username={username}
                        confirmCode={confirmCode}
                        emailError={emailError}
                        loading={loading}
                        setEmailError={setEmailError}
                    />

                    <Typography textAlign={'center'}>
                        {t('HaveAccount')}
                        <Link to={'/login'} style={{ color: '#04C900' }}>
                            {t('SignIn')}
                        </Link>
                    </Typography>
                </Box>
            </Box>
            {!isMobile && (
                <Box className={styles.imageSection} sx={{ overflow: 'hidden' }}>
                    <img className={styles.image} src={backgroundPhotoSrc} alt="home-image" />
                </Box>
            )}
        </Box>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPage);
